"use client";

import { createContext, type ReactNode, use } from "react";

import { useEvmEnvironment } from "../hooks/use-evm-environment";

type EvmEnvironmentState = ReturnType<typeof useEvmEnvironment>;

const EvmEnvironmentContext = createContext<EvmEnvironmentState>(null!);

export function EvmEnvironmentProvider({ children }: { children: ReactNode }) {
  const evmEnvironment = useEvmEnvironment();
  return <EvmEnvironmentContext value={evmEnvironment}>{children}</EvmEnvironmentContext>;
}

export function useEvmEnvironmentContext(): EvmEnvironmentState {
  return use(EvmEnvironmentContext);
}
